module.exports = __webpack_public_path__ + "img/birdushka.e45b38f6.png";